module.exports = __webpack_public_path__ + "static/media/calendar-regular.3b052ba8.svg";